import {
    ActivityProjection,
    IActivity,
    IActivityCreate,
    IActivityTable,
    IPagedData,
    IPagedSearch,
    TableStatus,
} from '@evencel/models';

export class GetActivity {
    public static readonly type = '[Activity] GetActivity';
    constructor(public id: string, public projection = 'general') {}
}

export class GetCurrentActivity {
    public static readonly type = '[Activity] GetCurrentActivity';
    constructor(public projection = 'general') {}
}

export class SearchActivitys {
    public static readonly type = '[Activity] SearchActivitys';
    constructor(public data: IPagedSearch) {}
}

export class CreateActivity {
    public static readonly type = '[Activity] SaveActivity';
    constructor(public activity: IActivityCreate) {}
}

export class RestActivity {
    public static readonly type = '[Activity] RestActivity';
}

export class UpdateActivity {
    public static readonly type = '[Activity] UpdateActivity';
    constructor(public activity: IActivity, public projection: string = ActivityProjection.general) {}
}

export class DeleteActivity {
    public static readonly type = '[Activity] DeleteActivity';
    constructor(public activity: IActivityTable) {}
}

export class RestoreActivity {
    public static readonly type = '[Activity] RestoreActivity';
    constructor(public activity: IActivityTable) {}
}

export class GetActivitysResponse {
    public static readonly type = '[Activity] GetActivitysResponse';
    constructor(public pagedData: IPagedData<IActivity>, public status: TableStatus) {}
}

export class GetActivityResponse {
    public static readonly type = '[Activity] GetActivityResponse';
    constructor(public activity: IActivity) {}
}
